import styled from 'styled-components';
import { LOT_THEME } from '../lot.common.styles';
// import { CheckUrl } from '@/component-library';
import CheckUrl from '@/component-library/svg/check.svg'

export const Label = styled.label`
  position: relative;
  display: block;
  height: 24px;
  width: fit-content;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
`;
export const Checkbox = styled.input.attrs({ type: 'checkbox' })`
  opacity: 0;
  width: 0;
  height: 0;
  position: absolute;

  &:checked + span {
    background: ${LOT_THEME.systemGreen};
  }
  &:checked + span::before {
    transform: translateX(16px);
    /* background-image: url(${CheckUrl}); */
    background-position: center;
    background-size: 12px 12px;
    background-repeat: no-repeat;
    opacity: 1;
  }
  &:active + span,
  &:focus + span {
    box-shadow: 0 0 0 2px ${LOT_THEME.systemBlue};
  }
`;

export const Span = styled.span`
  display: inline-block;
  width: 44px;
  height: 24px;
  background: ${LOT_THEME.backgroundPrimaryGray_active};
  border-radius: 20px;
  position: relative;
  cursor: pointer;
  transition: background 0.3s;

  &::before {
    content: '';
    position: absolute;
    left: 4px;
    top: 4px;
    width: 20px;
    height: 16px;
    background: #fff;
    border-radius: 16px;
    transition: transform 0.3s;
    box-shadow: 0 2px 4px 0 rgba(51, 49, 50, 0.16);
  }
`;
